<div class="dialog-header">
  <h2>Invitation</h2>
  <button class="x-btn" (click)="close()">&#10005;</button>
</div>

<div class="dialog-body">
  <div class="form-group">
    <label>First Name</label>
    <input type="text" [(ngModel)]="form.firstName" />
  </div>

  <div class="form-group">
    <label>Mobile</label>
    <input type="text" [(ngModel)]="form.mobile" />
  </div>

  <div class="form-group">
    <label>National ID</label>
    <input type="text" [(ngModel)]="form.nationalId" />
  </div>

  <div class="form-group">
    <label>Invites Count</label>
    <input
      type="number"
      [(ngModel)]="form.invitesCount"
      class="readonly-input"
      [readonly]="true"
    />
  </div>

  <button class="invite-btn" (click)="invite()">Invite</button>
</div>
